<template lang="pug">
  app-modal(
    titulo="Informações do Protesto",
    @closeModal="$emit('closeModal')"
  )
    template(slot="body")
      app-modal-visualiza-pdf(
        v-if="showModalVisualizaPdf",
        @closeModal="closeModalVisualizaPdf",
        :titulo="tituloModal",
        :tipo="tipoModal",
        :conteudo="conteudoModal",
        :isVTN="false",
        :isImagem="isImagem"
      )
      div(v-for="info in infosProtesto",)
        h4.titulo {{info.titulo}}
        el-collapse(v-model='abaAtiva')
          el-collapse-item(
            :key="info.titulo",
            :name='info.titulo',
          )
            template(slot="title")
              div.flex-between
                div
                  span {{ info.usuario }}
                div
                  span &nbsp {{ info.data }}

            el-row.margin-top
              div(v-if="info.motivo")
                p
                  b Motivo:
                  |  {{info.motivo}}
              p(style="font-weight: bold;") {{ info.labelJustificativa }}
              p(v-html="info.justificativa")
            el-row(v-if="info.anexos")
              el-table(
                :data='info.anexos',
                stripe
              )
                div(slot='empty')
                  span Não há anexos disponíveis.
                el-table-column.td-column-anexo(
                  prop='nome',
                )
                el-table-column.td-column-anexo(
                  align="center",
                  width="85"
                )
                  template(slot-scope='scope')
                    app-action-button(
                      :disabled="!isDocumentoParaVisualizacao(scope.row)"
                      :cor="!isDocumentoParaVisualizacao(scope.row) ? '#C0C4CC' : '#666666'",
                      :text="!isDocumentoParaVisualizacao(scope.row) ? 'Não é possível exibir esse arquivo': 'Visualizar' ",
                      icone="eye",
                      fontSize="18",
                      @click="abrirDocumento(scope.row)"
                    )
                    app-action-button(
                      icone="download",
                      nome="file_download",
                      @click="baixarAnexo(scope.row)",
                      hoverColor="#009f61",
                      text="Baixar anexo"
                    )
</template>

<script>
import AppModal from '@/components/AppModal'
import { mapActions } from 'vuex'
import utils from '@/utils/utils'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf'
import AppActionButton from '@/components/AppActionButton'
import FileSaver from 'file-saver'
import axios from '@/utils/api'

const {visualizarDocumentosPDF} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppModal,
    AppModalVisualizaPdf,
    AppActionButton
  },

  data () {
    return {
      infosProtesto: [],
      abaAtiva: 0,
      conteudoModal: '',
      conteudoModalSemid: null,
      tituloModal: '',
      isImagem: false,
      tipoModal: '',
      showModalVisualizaPdf: false
    }
  },

  props: {
    protesto: {
      type: Object,
      required: true
    }
  },

  methods: {
    ...mapActions({
      baixarDocumento: 'conversas/baixarDocumento'
    }),
    isDocumentoParaVisualizacao (row) {
      let extensao = utils.getExtensionFile(row.nome || row.fileName)
      return visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)
    },
    abrirDocumento (documento) {
      this.tipoModal = 'DOCUMENTO'
      this.tituloModal = 'Documento'
      this.conteudoModal = documento.id
      this.isImagem = this.isExtensaoImagem(documento)
      this.showModalVisualizaPdf = true
    },
    isExtensaoImagem (row) {
      let extensao = utils.getExtensionFile(row.nome || row.fileName)
      return visualizarDocumentosPDF.extensaoImagens.includes(extensao)
    },
    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    },
    async baixarAnexo (documento) {
      const file = await axios({
        method: 'POST',
        url: `documento/file`,
        data: documento,
        responseType: 'blob'
      })
      FileSaver.saveAs(file, documento.nome)
    }
  },
  created () {
    this.infosProtesto.push({
      titulo: 'Cadastro do Protesto: ',
      usuario: this.protesto.usuarioAbertura,
      data: this.protesto.dataAberturaFormatada,
      motivo: this.protesto.motivo,
      justificativa: this.protesto.justificativaAbertura,
      labelJustificativa: 'Justificativa: ',
      anexos: this.protesto.documentos
    })
    if (this.protesto.justificativaCancelamento) {
      this.infosProtesto.push({
        titulo: 'Cancelamento do Protesto: ',
        usuario: this.protesto.usuarioCancelamento,
        data: this.protesto.dataCancelamentoFormatada,
        justificativa: this.protesto.justificativaCancelamento,
        labelJustificativa: 'Justificativa do cancelamento: '
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .titulo {
    margin: 10px 0 10px 0;
  }
  .flex-between {
    width: 95%;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalVisualizarProtesto.vue